// extracted by mini-css-extract-plugin
export default {"accordion":"CharacterFilter_accordion__V3klE","clear":"CharacterFilter_clear__w68kf"};